import type { HandleClientError } from '@sveltejs/kit';
import { initErrorReporting, reportError } from '$lib/error-reporting';

const TRACES_SAMPLE_RATE = 0.1;
const CLIENT_ERROR_STATUS_MIN = 400;
const SERVER_ERROR_STATUS_MIN = 500;

initErrorReporting({
	dsn: 'https://daa7b557cd99555c0162f54c57d4fd8d@o4509252041834496.ingest.us.sentry.io/4509252076044288',
	// Adds request headers and IP for users, for more info visit:
	// https://docs.sentry.io/platforms/javascript/guides/sveltekit/configuration/options/#sendDefaultPii
	sendDefaultPii: true,
	tracesSampleRate: TRACES_SAMPLE_RATE,
	replaysSessionSampleRate: 0.1,
	replaysOnErrorSampleRate: 1.0
});

const isClientError = (status: number) =>
	status >= CLIENT_ERROR_STATUS_MIN && status < SERVER_ERROR_STATUS_MIN;

export const handleError: HandleClientError = ({ error, event, status }) => {
	console.warn('An error occurred on the client side:', error, event);
	if (!isClientError(status)) reportError(error);
};
